<template>
  <div id="Inquiries" class="row">
    <div class="col-12">
      <SectionTitle
        class="mt-3"
        reverse
        icon="fas fa-calendar-alt"
        :content="title"
      />
    </div>

    <div class="col-xs-12 col-sm-12">
      <DynamicFormList :items="value">
        <template #items="{ item, index }">
          <div class="col-12">
            <DynamicFormListItem
              :item="item"
              :no-actions="isReadOnly"
              class="bg-light-gray border-radius--light"
            >
              <template #default="{ active, toggle }">
                <FacilitatorInquiryItem
                  :item="item"
                  :show-attendee-user="showAttendeeUser"
                  :is-read-only="isReadOnly"
                  cols="col-md col-12"
                >
                  <template v-if="!isReadOnly && !active" #actions>
                    <div class="col pt-2 col-md-3 px-0">
                      <div
                        class="h-100 d-md-flex d-lg-flex justify-content-end align-items-center"
                      >
                        <MenuDropDown
                          title="Acciones"
                          :items="getMenuActions(toggle, index, item)"
                        />
                      </div>
                    </div>
                  </template>
                </FacilitatorInquiryItem>
                <template v-if="!isReadOnly && active">
                  <div
                    :style="{
                      'border-top': '1px solid #E2E2E2',
                      margin: '.5rem 0'
                    }"
                  />
                  <FacilitatorInquiryForm
                    :item="item"
                    :is-read-only="isReadOnly"
                    :show-attendee-user="showAttendeeUser"
                    :editting="active"
                    @submit="edit"
                    @cancel="toggle"
                  />
                </template>
              </template>
            </DynamicFormListItem>
          </div>
        </template>

        <template v-if="!isReadOnly" #form="{ toggle }">
          <FacilitatorInquiryForm
            :item="defaultItem"
            :is-read-only="isReadOnly"
            :show-attendee-user="showAttendeeUser"
            @submit="add"
            @cancel="toggle"
          />
        </template>

        <template v-if="!isReadOnly" #form-toggler="{ toggle }">
          <div>
            <template v-if="canAdd">
              <div class="text-right">
                <ActionButton
                  text="Añadir"
                  variant="success"
                  i="fas fa-file-plus"
                  @click="toggle"
                />
              </div>
            </template>
            <template v-if="!hasAnyItems">
              <ActivationButton
                text="Presione aquí para añadir consultas"
                @click.z="toggle"
              />
            </template>
          </div>
        </template>
      </DynamicFormList>
    </div>

    <div v-if="isReadOnly && !hasAnyItems" class="col-12">
      <div class="bg-light-gray border-radius--light py-4 text-center">
        No posee consultas
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from "SectionTitle";
import {
  ActivationButton,
  DynamicFormList,
  DynamicFormListItem,
  ActionButton
} from "@/components/common";
import { mapState } from "vuex";
import { statusManagementStore } from "@/components/pei/ubication-tech-assistance/_store";
import MenuDropDown from "dropdown";
import FacilitatorInquiryForm from "./_components/FacilitatorInquiryForm";
import FacilitatorInquiryItem from "./_components/FacilitatorInquiryItem";
import moment from "moment";
import { tapRequestStatusesEnum } from "@/components/pei/ubication-tech-assistance/_types";

export default {
  name: "FacilitatorInquiries",
  components: {
    SectionTitle,
    ActivationButton,
    FacilitatorInquiryForm,
    FacilitatorInquiryItem,
    DynamicFormList,
    DynamicFormListItem,
    ActionButton,
    MenuDropDown
  },
  props: {
    submittedDate: { type: String, required: true },
    personWhoAttends: { type: String, default: null },
    isReadOnly: { type: Boolean, default: false },
    canDelete: { type: Boolean, default: true },
    showAttendeeUser: { type: Boolean, default: true },
    value: { type: Array, default: () => [] },
    title: {
      type: String,
      default: "Consultas"
    }
  },
  data: () => ({ activeForms: false }),
  computed: {
    ...mapState(statusManagementStore, ["currentStatus"]),
    currentUser() {
      return (
        this.userProfile.firstname + " " + this.userProfile.lastpaternalname
      );
    },
    hasAnyItems() {
      return !!this.value.length;
    },
    hasPermission() {
      return !this.isReadOnly && this.canDelete;
    },
    canAdd() {
      return this.hasAnyItems;
    },
    defaultItem() {
      const date =
        this.currentStatus?.id === tapRequestStatusesEnum["Proceso de Consulta"]
          ? new Date()
          : this.submittedDate ?? new Date();
      return {
        dateReceived: new Date(moment(date).format("YYYY-MM-DD")),
        personWhoAttends: this.personWhoAttends
      };
    }
  },
  methods: {
    isEqualUser(item) {
      return (
        !this.showAttendeeUser ||
        (this.showAttendeeUser && this.currentUser == item.personWhoAttends)
      );
    },
    getMenuActions(toggle, index, item) {
      let menus = [];
      let isEqualUser = this.isEqualUser(item);
      if (isEqualUser) {
        menus.push({
          label: "Editar",
          icon: "fas fa-edit fa-fw text-green",
          border: "bottom",
          click: toggle
        });
      }
      if (this.hasPermission || isEqualUser) {
        menus.push({
          label: "Eliminar",
          icon: "fas fa-times-circle fa-fw text-red",
          click: () => this.remove(index)
        });
      }
      return menus;
    },
    add(item, reset) {
      if (this.isReadOnly) {
        return;
      }
      this.value.push(item);
      reset();
    },
    edit(item, reset) {
      if (this.isReadOnly) {
        return;
      }
      const index = this.value.findIndex(x => x.id === item.id);
      this.value.splice(index, 1, item);
      reset();
    },
    remove(index) {
      if (this.isReadOnly) {
        return;
      }
      this.value.splice(index, 1);
    }
  },
  watch: {
    value: {
      handler() {
        this.$emit("input", this.hasAnyItems);
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
